export default __webpack_public_path__ + "static/O0024-0f966ba9e42dea0d29f0fe02a696acff.png";